import { Box, Divider, FormHelperText, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../components/Buttons/BackButton';
import LocationFormRequestSteps from '../components/FormContainers/applicationLocation/LocationFormRequestSteps';
import { ILocProps } from '../components/FormContainers/applicationLocation/Types';
import FormSkeleton from '../components/Skeletons/FormSkeleton';
import { createLocationFormInitialValues } from '../lib/static/locations/initialValues';
import Theme from '../Themes/main.theme';
import HttpService from '../services/HttpService';
import { transformGreekToEnglish } from '../lib/helperFuncs';
import i18n from '../i18n';
import { useFromAccessLogic } from '../hooks/useFromAccessLogic';
import { AppleTitleNamingKeys } from '../lib/generalTypes';

const LocationFormRequest = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { id } = useParams();

  const [data, setData] = React.useState('');
  const [name, setName] = React.useState<string>('');
  const [surname, setSurname] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>('');
  const [phone, setPhone] = React.useState<string>('');

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();


  const { availableForms, isLoading: isFormPublishedLoading } =
  useFromAccessLogic(AppleTitleNamingKeys.FilmingRequest);


  React.useEffect(() => {
    if (!isFormPublishedLoading) {
      if (!availableForms.is_published) {
        enqueueSnackbar(t('Το αίτημα δεν είναι διαθέσιμο αυτή τη στιγμή.'), { variant: 'info' });
        navigate('/location');
      }
    }
  }, [isFormPublishedLoading]);


  const getManagerContantInfo = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/responsible_user/${id}`);
    setName(response.data?.name);
    setSurname(response.data?.lastname);
    setPhone(response.data.mobile);
    setEmail(response.data?.email);
  };

  document.title = t('Αίτημα Ενδιαφέροντος για Γύρισμα στην Τοποθεσία ');

  const onSubmit = async (values: ILocProps) => {
    const addedValues = { ...values, omekaId: Number(id) };
    const resp = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/applications/locations/filming`, addedValues);
    try {
      if (resp.status === 201) {
        enqueueSnackbar(t('Το αίτημα σας υποβλήθηκε επιτυχώς!'), { variant: 'success' });
        navigate('/location');
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.'), { variant: 'error' });
    }
  };

  React.useEffect(() => {
    const getData = async () => {
      try {
        const locationInfo = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/${id}`);
        setData(locationInfo.data.item['dcterms:title'][0]['@value']);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };
    getManagerContantInfo();
    getData();
  }, []);

  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate(`/location/details/${id}`)} />
      </Box>
      <Typography sx={{ my: 2 }} variant='h2'
        color={Theme?.labelColor?.main}>{t('Αίτημα Ενδιαφέροντος για Γύρισμα στην Τοποθεσία ') + (i18n.language === 'en'
          ? transformGreekToEnglish(`${data}`)
          : data)}
      </Typography>
      <Divider sx={{ mb: 2, border: 1, color: Theme?.dividerColor?.main }} />
      {isLoading || isFormPublishedLoading
        ? <FormSkeleton lines={6} />
        : <>
          <FormHelperText>
            <Typography
              variant='body1'
              fontStyle='italic'
              sx={{
                marginLeft: '12px',
                marginTop: '10px',
                fontWeight: 'bolder',
              }}
            >
              {t('Πρέπει να συμπληρωθούν όλα τα υποχρεωτικά πεδία, ώστε να κάνετε υποβολή το αίτημα σας.')}
            </Typography>
          </FormHelperText>
          <LocationFormRequestSteps
            omekaLocationId={id as any}
            initialValues={{
              ...createLocationFormInitialValues,
              name: name, surname: surname,
              tel: phone, email_manage: email
            }}
            onSubmit={onSubmit}
          />
        </>
      }
    </>
  );
};

export default LocationFormRequest;